export function voiceScroll() {
  const sections = document.querySelectorAll(".p-top-voice");

  sections.forEach((section) => {
    const list = section.querySelector(".p-top-voice__items");
    const bar = section.querySelector(".p-top-voice__progressBar");
    const track = section.querySelector(".p-top-voice__progressTrack");

    if (!list || !bar || !track) return;

    const update = () => {
      const { scrollLeft, scrollWidth, clientWidth } = list;
      const trackWidth = track.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      if (maxScroll <= 0) {
        bar.style.width = `${trackWidth}px`;
        bar.style.transform = "translateX(0)";
        return;
      }

      const thumbWidth = (clientWidth / scrollWidth) * trackWidth;
      const progress = scrollLeft / maxScroll;
      const thumbLeft = progress * (trackWidth - thumbWidth);

      bar.style.width = `${thumbWidth}px`;
      bar.style.transform = `translateX(${thumbLeft}px)`;
    };

    list.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });
}
